<template>
  <div class="flex flex-wrap items-start mb-4 pb-4 border-b-2">
    <div class="md:w-4/5 flex flex-col">
      <span class="text-left pb-2 uppercase text-sm tracking-wider">Pregunta</span>
      <input
        :class="{'border-red-500': question.error}"
        class="bg-gray-200 appearance-none border-2 border-indigo-500 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-indigo-300"
        type="text"
        v-model="question.value"
      />
      <p v-if="question.error" class="text-red-500 text-xs italic text-left">Ingrese la pregunta.</p>
    </div>
    <div class="md:w-1/5 flex justify-center">
      <button
        type="button"
        class="flex items-center px-2 py-1 rounded bg-red-500 text-gray-100 hover:bg-red-700"
        @click="remove"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current" viewBox="0 0 24 24">
          <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </button>
    </div>
    <div class="w-full flex items-center mt-3">
      <span class="text-left uppercase text-xs tracking-wider">Opciones</span>
      <button
        type="button"
        class="flex items-center px-2 py-2 ml-2 rounded-full bg-gray-700 text-gray-100 hover:bg-gray-900"
        @click="addOption"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 fill-current" viewBox="0 0 24 24">
          <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </button>
      <p
        v-if="question.optionError"
        class="ml-3 text-red-500 text-xs italic text-left"
      >Deben llenarse todas las opciones.</p>
    </div>
    <div class="w-full flex flex-wrap mt-3">
      <div
        v-for="(option, index) in question.options"
        :key="index"
        class="relative w-1/3 pr-2 py-2"
      >
        <input
          :class="{'border-red-500': option === '' && question.optionError}"
          class="bg-gray-200 appearance-none border-2 border-indigo-500 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-indigo-300"
          type="text"
          v-model="question.options[index]"
        />
        <button
          type="button"
          class="absolute top-0 right-0 flex items-center px-1 py-1 -mt-1 rounded-full border-2 border-gray-500 bg-gray-700 text-gray-100 hover:bg-gray-900"
          @click="removeOption(index)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 fill-current" viewBox="0 0 24 24">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "multiple-question",
  methods: {
    remove() {
      this.$emit("click");
    },
    addOption() {
      this.question.options.push("");
    },
    removeOption(index) {
      this.question.options.splice(index, 1);
    }
  },
  props: {
    question: {
      required: true
    }
  }
};
</script>

<style scoped>
</style>